
































import Vue from 'vue';
// @ts-ignore
import FocusLock from 'vue-focus-lock';

import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';

import './ConfirmDialog.scss';

@Component({
  components: { FocusLock }
})
export default class ConfirmDialog extends Vue {
  @Prop(String) maxWidth!: string;
  @Prop(Boolean) loading!: boolean;
  @Prop({ type: Boolean, default: true }) actionRendering!: boolean;
  @Prop(Boolean) disabledAcceptButton!: boolean;
  @Prop() readonly refFocusButton!: HTMLElement;

  public isDialogOpen: boolean = false;

  private activeElement!: HTMLElement;

  public show(): void {
    this.activeElement = document.activeElement as HTMLElement;
    this.isDialogOpen = true;
  }

  public close(): void {
    this.isDialogOpen = false;

    setTimeout(() => {
      this.refFocusButton.focus();
    }, 350);
  }

  private accepted(): void {
    this.$emit('accepted-event');
  }

  private canceled(): void {
    this.$emit('canceled-event');
    this.close();
  }

  @Watch('isDialogOpen')
  private watchOnIsDialogOpen() {
    if (this.isDialogOpen) {
      const dialog = document.querySelector('.v-dialog--active')!;

      if (dialog !== null) {
        dialog.setAttribute('tabindex', '-1');
        dialog.setAttribute('role', 'dialog');
      }
    }
  }
}
